import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import "../../components/PetTypeList/PetTypeList.css";

const AssetTypeList = ({
  assetDetailResponse,
  GetId,
  openAddProfile,
  setOpenAddProfile,
  openProfile,
  setOpenProfile,
  baseImageURL,
}) => {
  function HandleChange(param) {
    GetId(param);
  }

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const options = {
      day: "numeric",
      month: "short",
      year: "numeric",
    };

    const formattedDate = new Date(dateString).toLocaleString("en-US", options);
    return formattedDate;
  };

  return (
    <div className="container-fluid">
      <div className="PetTypeList">
        <table>
          <thead>
            <tr className="PetTypeListHeading">
              <th>Sr No.</th>
              <th>Product Name</th>
              <th>Category</th>
              <th>Assigned To</th>
              <th>Date of Issue</th>
              <th>Availablity</th>
              <th>Status</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {assetDetailResponse && assetDetailResponse.length > 0 ? (
              assetDetailResponse.map((AssetType, index) => (
                <tr key={AssetType.Tseed}>
                  <td>{index + 1}</td>
                  <td>{AssetType.product_name}</td>
                  <td>{AssetType.product_type}</td>
                  <td>
                    {AssetType.Is_Available === 1 || AssetType.Is_Active === 0
                      ? "N/A"
                      : AssetType.current_owner}
                  </td>
                  <td>
                    {AssetType.Is_Available === 1 || AssetType.Is_Active === 0
                      ? "N/A"
                      : formatDate(AssetType.date_of_issue)}
                  </td>

                  <td
                    style={{
                      color: AssetType.Is_Available ? "green" : "red",
                      fontSize: "14px",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "5px",
                    }}
                  >
                    {" "}
                    {AssetType.Is_Available ? "Available" : "Not Available"}
                  </td>

                  <td
                    style={{
                      color: AssetType.Is_Active ? "green" : "red",
                      fontSize: "14px",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "5px",
                    }}
                  >
                    {AssetType.Is_Active ? "Active" : "Inactive"}
                  </td>

                  <td>
                    <button
                      style={{ height: "30px", width: "38px" }}
                      onClick={() => {
                        HandleChange(AssetType.Tseed);
                        setOpenProfile(!openProfile);
                        setOpenAddProfile(false);
                      }}
                    >
                      <SearchIcon className="icon" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">No assets available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AssetTypeList;
